import pimg1 from '../images/conditions/Orthopedics and joint conditions.jpg';
import pimg2 from '../images/conditions/Sports.Injuries.jpg';
import pimg3 from '../images/conditions/CronicPainManagement.jpg';
import pimg4 from '../images/conditions/AutoimmuneConditions.jpg';
import pimg5 from '../images/conditions/AntiAging.jpg';
import pimg6 from '../images/conditions/SexualWellness.jpg';


import p2img1 from '../images/project-single/1.jpg'
import p2img2 from '../images/project-single/2.jpg'
import p2img3 from '../images/project-single/3.jpg'
import p2img4 from '../images/project-single/4.jpg'
import p2img5 from '../images/project-single/5.jpg'
import p2img6 from '../images/project-single/6.jpg'






const Projects = [
    {
        id: '1',
        title: 'Joint Pain & Arthritis',
        subtitle: 'Knee, Hip, Shoulder & Spine',
        docomunt: 'Advanced stem cell therapy for osteoarthritis, rheumatoid arthritis, and joint degeneration. Amped Therapeutics specializes in treating knee, hip, shoulder, and spine conditions using autologous procedures. Our regenerative approach reduces inflammation, stimulates cartilage repair, and restores joint function without surgery.',
        slug: 'joint-pain-arthritis',
        pimg1: pimg1,
        pSimg: p2img1,
        location: 'Amped Therapeutics',
        date: 'Regenerative Treatment',
    },
    {
        id: '2',
        title: 'Sports Injuries',
        subtitle: 'Athletic Performance & Recovery',
        docomunt: 'Specialized stem cell treatments for sports-related injuries including torn ligaments, tendon damage, muscle tears, and cartilage injuries. Amped Therapeutics helps athletes and active individuals recover faster with regenerative medicine protocols that accelerate healing and restore peak performance.',
        slug: 'sports-injuries',
        pimg1: pimg2,
        pSimg: p2img2,
        location: 'Amped Therapeutics',
        date: 'Advanced Recovery Protocols',
    },
    {
        id: '3',
        title: 'Chronic Pain Management',
        subtitle: 'Back, Neck & Neuropathic Pain',
        docomunt: 'Innovative stem cell therapy for chronic pain conditions including back pain, neck pain, sciatica, neuropathy, and fibromyalgia. Dr. Pereira\'s 25+ years of pain management expertise combined with regenerative medicine offers lasting relief without dependency on medications or invasive procedures.',
        slug: 'chronic-pain-management',
        pimg1: pimg3,
        pSimg: p2img3,
        location: 'Amped Therapeutics',
        date: 'Integrative Pain Solutions',
    },
    {
        id: '4',
        title: 'Autoimmune Conditions',
        subtitle: 'Immune System Restoration',
        docomunt: 'Advanced stem cell therapy for autoimmune conditions including rheumatoid arthritis, lupus, multiple sclerosis, and inflammatory bowel disease. Amped Therapeutics uses regenerative medicine to help modulate immune response, reduce inflammation, and restore quality of life naturally.',
        slug: 'autoimmune-conditions',
        pimg1: pimg4,
        pSimg: p2img4,
        location: 'Amped Therapeutics',
        date: 'Immunomodulation Therapy',
    },
    {
        id: '5',
        title: 'Anti-Aging & Wellness',
        subtitle: 'Regenerative Aesthetics',
        docomunt: 'Cutting-edge stem cell treatments for age-related conditions including skin rejuvenation, hair restoration, facial aesthetics, and overall vitality enhancement. Amped Therapeutics offers comprehensive anti-aging protocols to help you look and feel your best at any age.',
        slug: 'anti-aging-wellness',
        pimg1: pimg5,
        pSimg: p2img5,
        location: 'Amped Therapeutics',
        date: 'Aesthetic Medicine',
    },
    {
        id: '6',
        title: 'Sexual Wellness',
        subtitle: 'Intimate Health Optimization',
        docomunt: 'Discreet, professional stem cell protocols for erectile dysfunction, Peyronie\'s disease, and female sexual wellness. Amped Therapeutics\' specialized team combines advanced regenerative medicine with compassionate, confidential care for both men\'s and women\'s intimate health concerns.',
        slug: 'sexual-wellness',
        pimg1: pimg6,
        pSimg: p2img6,
        location: 'Amped Therapeutics',
        date: 'Confidential Care',
    },




]
export default Projects;






